import { render } from "./Installation.vue?vue&type=template&id=728bb4cc"
import script from "./Installation.vue?vue&type=script&lang=js"
export * from "./Installation.vue?vue&type=script&lang=js"

import "./Installation.vue?vue&type=style&index=0&id=728bb4cc&lang=css"

import exportComponent from "/home/runner/work/web/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__